import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { useCopyToClipboard } from '../../../../../utils/copy';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import { StyledCardSection } from '../../../../common/base/Card';
import Skeleton from '../../../../common/base/Skeleton';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
const OutpostStaticIPSections: React.FC<{
  show_grouped: boolean;
}> = t0 => {
  const $ = _c(25);
  const {
    show_grouped
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const copyToClipboard = useCopyToClipboard();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = APIMethodKeys.billing.getOutpostStaticIPs();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== HookdeckAPI.billing) {
    t2 = () => HookdeckAPI.billing.getOutpostStaticIPs();
    $[1] = HookdeckAPI.billing;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: fleets,
    error
  } = useSWR(t1, t2);
  if (error) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <StyledCardSection muted={true} p={3}><Text size="s">Outpost IP addresses could not be loaded. Refresh to try again.</Text></StyledCardSection>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  if (!fleets) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <StyledCardSection muted={true} p={3}><Skeleton h={{
          px: 20
        }} w={{
          px: 240
        }} /></StyledCardSection>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== fleets) {
    t3 = new Set(fleets.flatMap(_temp));
    $[5] = fleets;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = [...t3];
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const ips = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      direction: "column",
      align: "flex-start",
      gap: 3
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      align: "center",
      justify: "space-between",
      gap: 2
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = show_grouped ? "Outpost IP addresses" : "Dedicated Hookdeck IP addresses";
  let t8;
  if ($[11] !== t7) {
    t8 = <Text semi={true} size="s">{t7}</Text>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== copyToClipboard || $[14] !== ips) {
    t9 = <Button ghost={true} icon="copy" m={-1} onClick={() => copyToClipboard(ips.join(", "))} />;
    $[13] = copyToClipboard;
    $[14] = ips;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <Div w={100} flex={t6}>{t8}{t9}</Div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      align: "flex-start",
      gap: 2,
      wrap: true
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== ips) {
    t12 = <Div flex={t11}>{ips.map(_temp2)}</Div>;
    $[20] = ips;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12) {
    t13 = <StyledCardSection muted={true} p={3} flex={t5}>{t10}{t12}</StyledCardSection>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default OutpostStaticIPSections;
function _temp(fleet) {
  return fleet.ips;
}
function _temp2(address) {
  return <Badge mono={true} subtle={true} neutral={true} key={address}>{address}</Badge>;
}